export function downloadFile(filename, text) {
  let element = document.createElement('a');
  element.setAttribute(
    'href',
    'data:text/plain;charset=utf-8,' + encodeURIComponent(text)
  );
  element.setAttribute('download', filename);

  element.style.display = 'none';
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
}

export function filterSelect(option, filter) {
  let res = true;

  if (filter.trim() !== '') {
    let arrayToSearch = option.wording.split(' ');
    let arrayKeywords = filter.split(' ');

    function searchLikeGoogle(arr, val) {
      return arr.some(function (arrVal) {
        return (
          arrVal
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()
            .indexOf(
              val
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .toLowerCase()
            ) === 0
        );
      });
    }

    for (let i = 0; i < arrayKeywords.length; i++) {
      if (!searchLikeGoogle(arrayToSearch, arrayKeywords[i])) {
        res = false;
      }
    }
  }

  return res;
}
